/*
 * Copyright (C) 2025 Hendrik. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 * Written by Hendrik, December 28, 2025.
 */

import axios from 'axios';

// Configure axios to send cookies with all requests
axios.defaults.withCredentials = true;

// Add auth token to all requests
axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers = config.headers || {};
        // Axios v1 may use AxiosHeaders rather than a plain object.
        if (typeof config.headers.set === 'function') {
            config.headers.set('Authorization', `Bearer ${token}`);
        } else {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Also send in body for POST requests
        if (config.method === 'post' && config.data) {
            // Handle FormData (for file uploads)
            if (config.data instanceof FormData) {
                config.data.append('auth_token', token);
            }
            // Handle JSON string
            else if (typeof config.data === 'string') {
                const data = JSON.parse(config.data);
                data.auth_token = token;
                config.data = JSON.stringify(data);
            }
            // Handle plain objects
            else {
                config.data = { ...config.data, auth_token: token };
            }
        }
    }
    return config;
});

export default axios;
